<template>
    <ExclamationCircleIcon v-if="hasExclamationStatus" class="error-icon" />
    <i v-else-if="status"
        class="icon-ok-circle"
        :data-status="status"></i>
</template>
<script setup lang="ts">
  import { computed } from "vue";
  import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';
  import { TabStatus } from "@/types/tabs";
  
  const props = defineProps<{
        status: string | undefined;
    }>();

  const hasExclamationStatus = computed(() => props.status == TabStatus.Exclamation);
  
</script>
<style scoped>
  .error-icon {
    width: 38px;
    height: 38px;
    color: #e31838;
    margin-right: 5px;
    vertical-align: middle;
  }
</style>